import { Http } from '../../shared';
import { settings } from '../../settings';
import  uuid  from '../../helpers/uuid';

export class TicsentService {
    constructor() {
        this.http = new Http();
        this.service_url = settings.gateway_api.base_url;
    }
    async getCalendar(query) {
        query= {...query, search_id: uuid.generate() };
        var response = await this.http.get(`${this.service_url}/ticsnet-travel-search/calendar?${new URLSearchParams(query)}`);
        if(response.data)
        {
            response.data= [...response.data, '2025-05-17'];
        }
        return response.data;
    }


}
